

import GraciasPorContactar from "../../../components/contactComponent/graciasPorContactar/graciasPorContactar";
import Footer from "../../../components/globalComponents/footer/footer";
import GradientLine from "../../../components/globalComponents/gradientLine/gradientLine";
import Menu from "../../../components/globalComponents/headerMenu/menu";
import SocialIcons from "../../../components/globalComponents/socialIcons/socialIcons";
import "./formularioEnviado.scss"



const FormularioEnviado = () => {
    

    return(
        <div>
            <Menu />
            <GraciasPorContactar/>
            <SocialIcons />
            <GradientLine />
            <Footer />
        </div>
        
    )
}

export default FormularioEnviado;